import { render, staticRenderFns } from "./timeMagn.vue?vue&type=template&id=1bcec18a&scoped=true&"
import script from "./timeMagn.vue?vue&type=script&lang=js&"
export * from "./timeMagn.vue?vue&type=script&lang=js&"
import style0 from "./timeMagn.vue?vue&type=style&index=0&id=1bcec18a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcec18a",
  null
  
)

export default component.exports